import { isEmpty } from 'remeda';

const VARIABLE_TOKEN = /\{\{\s*([\w.]+)\s*\}\}/g;
const TAG_OR_COMMENT = /<!--[\s\S]*?-->|<[^>]+>/g;
const VARIABLE_PILL = /<span[^>]*\bdata-variable="([^"]*)"[^>]*>[\s\S]*?<\/span>/gi;

export const VARIABLE_PILL_CLASS = 'template-variable';

type VariableSegment = { type: 'text'; text: string } | { type: 'variable'; value: string };

export const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

// Only text between tags reaches `transform`, so a token inside an attribute
// such as href="{{debtor_portal_link}}" is never rewritten.
const replaceOutsideMarkup = (html: string, transform: (text: string) => string): string => {
  let result = '';
  let lastIndex = 0;

  for (const match of html.matchAll(TAG_OR_COMMENT)) {
    result += transform(html.slice(lastIndex, match.index)) + match[0];
    lastIndex = match.index + match[0].length;
  }

  return result + transform(html.slice(lastIndex));
};

export const renderVariablePill = (value: string, label: string): string =>
  `<span class="${VARIABLE_PILL_CLASS}" data-variable="${escapeHtml(value)}" contenteditable="false">${escapeHtml(label)}</span>`;

export const variablesToPills = (html: string, labelOf: (value: string) => string): string =>
  replaceOutsideMarkup(html, text =>
    text.replace(VARIABLE_TOKEN, (_match, value: string) =>
      renderVariablePill(value, labelOf(value)),
    ),
  );

export const pillsToVariables = (html: string): string =>
  html.replace(VARIABLE_PILL, (_match, value: string) => `{{${value}}}`);

// Splitting on a regex with a capture group interleaves the captures, so every
// odd index is a variable name and every even index the text around it.
export const splitOnVariables = (text: string): VariableSegment[] =>
  text.split(VARIABLE_TOKEN).flatMap((part, index): VariableSegment[] => {
    if (index % 2 === 1) return [{ type: 'variable', value: part }];
    return isEmpty(part) ? [] : [{ type: 'text', text: part }];
  });
